import Vue from "vue/dist/vue.js";
import Swiper from "swiper";

export default class HelpSingle {
  constructor() {
    console.log("HelpSingle :: init");

    new Vue({
      el: "#help-single",
      data() {
        return {
          helpLength: 3,
          helps: [],
        };
      },
      mounted() {
        this.allCaptionDivs =
          this.$refs.article.querySelectorAll(".wp-caption");
        this.removeCaptionDiv();
        this.allContentImages = this.$refs.article.querySelectorAll("img");
        this.wrapImages();
        this.helps = this.$refs.listing.querySelectorAll(".bloc-post");
        this.showHelps();
      },
      methods: {
        removeCaptionDiv() {
          // Remove div.wp-caption that is created by WP and comes with a giant inline width
          for (let i = 0; i < this.allCaptionDivs.length; i++) {
            while (this.allCaptionDivs[i].firstChild) {
              this.allCaptionDivs[i].parentNode.insertBefore(
                this.allCaptionDivs[i].firstChild,
                this.allCaptionDivs[i]
              );
            }
            this.allCaptionDivs[i].parentNode.removeChild(
              this.allCaptionDivs[i]
            );
          }
        },
        wrapImages() {
          // Wrap Wysiwyg images in div to style them
          for (let i = 0; i < this.allContentImages.length; i++) {
            let $wrapperDiv = document.createElement("div");
            $wrapperDiv.classList.add("img-wrapper");
            this.wrap(this.allContentImages[i], $wrapperDiv);
          }
          this.$refs.article.classList.remove("transparent");
        },
        wrap(el, wrapper) {
          el.parentNode.insertBefore(wrapper, el);
          wrapper.appendChild(el);
        },
        loadmore() {
          this.helpLength += 3;
          this.showHelps();
        },
        showHelps() {
          // Help article listing at the bottom of the page
          for (let i = 0; i < this.helps.length; i++) {
            if (i > this.helpLength - 1) {
              this.helps[i].style.visibility = "hidden";
              this.helps[i].style.height = "0px";
            } else {
              this.helps[i].style.visibility = "";
              this.helps[i].style.height = "";
              this.helps[i].style.opacity = "1";
            }
          }

          if (this.helpLength >= this.helps.length) {
            this.$refs.loadmore.style.display = "none";
          }
        },
      },
    });

    const swipers = document.querySelectorAll(".chrono-help-swiper");

    swipers.forEach((swiper, idx) => {
      const el = swiper.querySelector(".swiper-container");
      const imageSwiper = new Swiper(el, {
        loop: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        on: {
          init: function () {
            const prevBtns = [];
            const nextBtns = [];

            Array.from(this.slides).forEach((slide, idx) => {
              const prevBtn = slide.querySelector(`.swiper-button-prev-${idx}`);
              const nextBtn = slide.querySelector(`.swiper-button-next-${idx}`);

              prevBtns.push(prevBtn);
              nextBtns.push(nextBtn);

              if (prevBtn) {
                prevBtn.addEventListener("click", () => {
                  this.slidePrev();
                });
              }

              if (nextBtn) {
                nextBtn.addEventListener("click", () => {
                  this.slideNext();
                });
              }
            });
          },
        },
      });
    });
  }
}
